export function init($name) {
    if (!$($name).length) {
        return;
    }

    let contents = $name + ' .contents';
    let logos = $name + ' .logos';
    let length = $(contents).find('li').length;

    if ($(contents).length && $(logos).length) {
        $(contents).slick({
            dots: false,
            arrows: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 12000,
            variableWidth: false,
            centerMode: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            swipe: true,
            swipeToSlide: true,
            asNavFor: logos
        });

        $(logos).slick({
            dots: false,
            arrows: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 12000,
            variableWidth: true,
            centerMode: true,
            slidesToScroll: 1,
            swipe: true,
            swipeToSlide: true,
            focusOnSelect: true,
            asNavFor: contents,
            slidesToShow: 4,
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 3
                    }
                }
            ]
        });

        $(contents)[0].slick.slickGoTo(Math.floor(length / 2));
    }
}
